(function () {
  'use strict';
  function showEntryFlavor() {
    var selector = document.querySelector('[data-hfs][data-entry-variant]');
    if (!selector || selector.hasAttribute('data-entry-media-shown')) return;
    var variantId = selector.getAttribute('data-entry-variant');
    if (!variantId) return;
    var card = Array.prototype.find.call(selector.querySelectorAll('[data-hfs-card]'), function (item) {
      return String(item.getAttribute('data-flavor-variants') || item.getAttribute('data-id') || '').split(',').indexOf(variantId) !== -1;
    });
    var flavor = card && String(card.getAttribute('data-flavor') || '').toLowerCase();
    if (!flavor) return;
    var gallery = document.querySelector('media-gallery[data-hush-editorial-gallery]');
    // The shared Mint + Vanilla animation is the opening media for both flavors.
    if (!gallery || gallery.hasAttribute('data-hush-motion-gallery')) return;
    selector.setAttribute('data-entry-media-shown', 'true');
    window.customElements.whenDefined('media-gallery').then(function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var viewer = gallery.querySelector('[id^="GalleryViewer"]');
          var item = viewer && Array.prototype.find.call(viewer.querySelectorAll('[data-media-id]'), function (slide) {
            var photo = slide.querySelector('img');
            return photo && String(photo.alt || '').toLowerCase().indexOf(flavor) !== -1;
          });
          if (!item || typeof gallery.setActiveMedia !== 'function') return;
          // The editorial slides stay in their approved order. Use the gallery's
          // own thumbnail/slider synchronization for the requested flavor.
          if (gallery.querySelector('[id^="GalleryThumbnails"]')) gallery.setActiveMedia(item.getAttribute('data-media-id'), false);
        });
      });
    });
  }
  function init() {
    showEntryFlavor();
    var proof = document.querySelector('.hush-product-proof');
    if (!proof || document.querySelector('[data-hush-pdp-return]')) return;
    var main = proof.closest('section[id^="MainProduct-"]') || proof.closest('[id^="MainProduct-"]');
    if (!main) return;
    var bar = document.createElement('nav');
    bar.className = 'hush-pdp-return';
    bar.setAttribute('data-hush-pdp-return', '');
    bar.setAttribute('aria-label', 'Return to your pack');
    bar.hidden = true;
    bar.innerHTML = '<span class="hush-pdp-return__copy"><strong>Choose your flavors.</strong>Mint, Vanilla, or both.</span><a href="#hush-pack-builder">Choose your pack</a>';
    document.body.appendChild(bar);
    var action = bar.querySelector('a');
    var mobile = window.matchMedia('(max-width: 749px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var scheduled = false;
    function visible(element) {
      if (element.hidden || element.closest('[hidden], [inert]')) return false;
      var details = element.closest('details');
      if (details && !details.open) return false;
      var rect = element.getBoundingClientRect();
      var style = window.getComputedStyle(element);
      return rect.width > 1 && rect.height > 1 && rect.right > 0 && rect.left < window.innerWidth &&
        rect.bottom > 0 && rect.top < window.innerHeight && style.visibility !== 'hidden' &&
        style.display !== 'none' && Number(style.opacity) !== 0;
    }
    function update() {
      scheduled = false;
      var target = document.getElementById('hush-pack-builder');
      var footer = document.querySelector('footer');
      var editing = document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName);
      var overlay = Boolean(document.querySelector('details[open] .menu-drawer, details[open] .search-modal, cart-drawer.active')) ||
        Array.prototype.some.call(document.querySelectorAll('[role="dialog"], cart-drawer, .menu-drawer, .search-modal'), visible);
      var show = mobile.matches && target && main.getBoundingClientRect().bottom < 70 &&
        (!footer || footer.getBoundingClientRect().top > window.innerHeight + 80) && !editing && !overlay;
      if (bar.hidden === Boolean(show)) bar.hidden = !show;
      var selected = main.querySelector('[data-hfs-progress].is-complete');
      var label = selected ? 'Review your pack' : 'Choose your pack';
      if (action.textContent !== label) action.textContent = label;
    }
    function schedule() { if (!scheduled) { scheduled = true; window.requestAnimationFrame(update); } }
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href="#hush-pack-builder"]');
      var target = document.getElementById('hush-pack-builder');
      if (!link || !target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
      schedule();
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('transitionend', schedule, true);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'open', 'aria-expanded', 'aria-hidden'] });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
}());
